import React, { useEffect } from 'react';
import delay from 'lodash/delay';
import { Oval } from 'react-loader-spinner';
import { useSelector, useDispatch } from 'react-redux';
import get from 'lodash/get';
import { Colors } from 'modules/theme';
import { Page } from 'modules/ui';
import { showNotification, Notification } from 'modules/notifications';
import { WelcomeLogo, AuthHeader, logout } from 'modules/auth';
import {
  verifyChangedEmail,
  getVerifyChangedEmailError,
  getVerifyChangedEmailSuccess,
} from '../redux';
import { useNavigate, useParams } from 'react-router-dom';

const styles = {
  container: {
    paddingTop: 64,
    textAlign: 'center',
  },
  title: {
    paddingTop: 60,
    paddingBottom: 25,
    fontWeight: 'bold',
    fontSize: 24,
    alignItems: 'center',
    textAlign: 'center',
  },
  error: {
    paddingTop: 60,
    color: Colors.error,
  },
};

export default function ChangedEmailVerificationPage() {
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();
  const verificationError = useSelector(getVerifyChangedEmailError);
  const verificationSuccess = useSelector(getVerifyChangedEmailSuccess);

  useEffect(() => {
    const token = get(params, 'token');

    dispatch(verifyChangedEmail(token));
  }, [dispatch, params]);

  useEffect(() => {
    if (verificationSuccess) {
      dispatch(
        showNotification({
          message: 'Your new email address is verified',
          type: Notification.TYPES.SUCCESS,
        }),
      );
      delay(() => {
        dispatch(logout());
      }, 3000);
    }
  }, [verificationSuccess, dispatch]);

  useEffect(() => {
    if (verificationError) {
      // return history.push({
      //   pathname: '/settings/change-email',
      //   state: {
      //     code: AUTH_CODES.VERIFICATION_LINK_EXPIRED,
      //   },
      // });
      return navigate('/settings/change-email');
    }
  }, [verificationError, navigate]);

  return (
    <Page
      className="pt-64"
      HeaderComponent={
        <AuthHeader
          showLogo={false}
          link="/"
          linkLabel={`Return to ${window.location.hostname}`}
        />
      }
    >
      <div style={styles.container}>
        <WelcomeLogo />
        <div style={styles.title}>Your new email is being verified</div>
        <Oval
          secondaryColor={Colors.darkBlue}
          color={Colors.darkBlue}
          width={40}
          height={40}
        />
      </div>
    </Page>
  );
}
